import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect } from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Texterror } from "../../../constants/Texterror";
import { useDispatch } from "react-redux";
import { createOrder } from "../../../redux/actions/dbactions/orderActions";

const NewOrder = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleCancel = () => {
    history.goBack();
  };

  useEffect(() => {
    // Perform any setup actions, such as fetching necessary data for form selectors
  }, [dispatch]);

  const handleOrderSubmit = (values) => {
    // Assume createOrder action is properly set up to handle the order creation
    dispatch(createOrder(values));
    history.goBack();
  };

  return (
    <div className="profile">
      <div className="card_white_box">
        <h5 className="globale-title">
          <span>Add Order</span>
        </h5>
        <Formik
          initialValues={{
            order_name: "",
            order_quantity: "",
            order_date: "",
            delivery_date: "",
            order_type: "", // New field for order type
            // Add other order-related fields as needed
          }}
          onSubmit={handleOrderSubmit}
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <Field
                      name="order_name"
                      placeholder="Order Name"
                      type="text"
                      className="form-control"
                    />
                    <ErrorMessage name="order_name" component={Texterror} />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <Field
                      name="order_quantity"
                      placeholder="Order Quantity"
                      type="number"
                      className="form-control"
                    />
                    <ErrorMessage name="order_quantity" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <Form.Label>Order Date</Form.Label>

                    <Field
                      name="order_date"
                      placeholder="Order Date"
                      type="date"
                      className="form-control"
                    />
                    <ErrorMessage name="order_date" component={Texterror} />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <Form.Label>Delivery Date</Form.Label>

                    <Field
                      name="delivery_date"
                      placeholder="Delivery Date"
                      type="date"
                      className="form-control"
                    />
                    <ErrorMessage name="delivery_date" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <Field
                      as="select"
                      name="order_type"
                      className="form-control"
                    >
                      <option value="">Select Order Type</option>
                      {/* Populate this with actual order types */}
                      <option value="type1">Type 1</option>
                      <option value="type2">Type 2</option>
                    </Field>
                    <ErrorMessage name="order_type" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="mini_edit">
                    <Button variant="secondary" onClick={handleCancel}>
                      Cancel
                    </Button>
                    <Button variant="primary" type="submit">
                      Add Order
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default NewOrder;
